import React from 'react';
import { Card, Avatar, Tag } from 'antd';
import {
    MailOutlined,
    PhoneOutlined,
    UserOutlined,
    NumberOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined
} from '@ant-design/icons';
import { getInitials } from '../../../../../utils/helper';

const EnhancedLeadsNotSentCardView = ({
    record,
    onCardClick,
}) => {
    const initials = getInitials(record.clientName || record.userEmail);

    return (
        <Card
            hoverable
            className="h-full relative"
            onClick={() => onCardClick && onCardClick(record)}
            style={{ padding: '16px' }}
        >
            <div className="space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3 overflow-hidden">
                        <Avatar
                            size={48}
                            className="flex-shrink-0 font-semibold text-lg !bg-primary"
                        >
                            {initials}
                        </Avatar>
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-base mb-1 truncate" title={record.clientName}>
                                {record.clientName || "N/A"}
                            </h3>
                            {record.userEmail && (
                                <div className="flex items-center text-gray-500 text-sm mb-0">
                                    <MailOutlined className="mr-1.5 flex-shrink-0" />
                                    <span className="truncate" title={record.userEmail}>
                                        {record.userEmail}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Details Section */}
                <div className="space-y-3 pt-2">
                    {/* Phone */}
                    {record.clientPhone && (
                        <div className="flex items-center justify-between">
                            <span className="text-sm text-gray-600 font-medium flex items-center">
                                <PhoneOutlined className="mr-2" />
                                Phone:
                            </span>
                            <span className="text-sm text-gray-700 truncate max-w-[60%]" title={record.clientPhone}>
                                {record.clientPhone}
                            </span>
                        </div>
                    )}

                    {/* On Trial */}
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium flex items-center">
                            {record.onTrial === 'Yes' ? <CheckCircleOutlined className="mr-2" /> : <CloseCircleOutlined className="mr-2" />}
                            On Trial:
                        </span>
                        <Tag color={record.onTrial === 'Yes' ? 'green' : 'red'}>
                            {record.onTrial || 'No'}
                        </Tag>
                    </div>

                    {/* Count */}
                    <div className="flex items-center justify-between border-t border-gray-200 pt-3 mt-3">
                        <span className="text-sm text-gray-600 font-medium flex items-center">
                            <NumberOutlined className="mr-2" />
                            Count:
                        </span>
                        <span className="text-base font-semibold text-primary">
                            {record.count}
                        </span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedLeadsNotSentCardView;